import { useState, useEffect, useCallback } from "react";
import { getAdminDashboardData } from "../api/adminDashboard";

export default function useAdminDashboard(filters = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback((f) => {
    setLoading(true);
    getAdminDashboardData(f)
      .then((res) => setData(res.data))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchData(filters);
  }, [JSON.stringify(filters)]);

  const refetch = useCallback((f) => fetchData(f), [fetchData]);

  return { data, loading, refetch };
}
